export default "__VITE_ASSET__9ec18a3c__"